import { Dispatch } from 'shared/store/store';
import { Box, Typography, Button, Grid, Container } from '@mui/material';
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../shared/utils/ui/Layout';
import styles from './home.module.scss'
import { ModalContract } from 'pages/contracts-pages/ModalContract';
import { useCheckRoleAccess } from 'shared/hooks/useCheckRoleAccess';
import { RouterGuard } from 'shared/components/RouteGuard';
import { accesRoles } from 'shared/models/roles';

// Importar iconos relevantes
import iconoDescarga from '../../shared/assets/images/icono-descarga.svg';
import iconoSubir from '../../shared/assets/images/subir-archivo.png';
import iconoContrato from '../../shared/assets/images/icono-contrato.png';
import logoGobernacion2024 from '../../shared/assets/images/logo-gobernacion-2024.png';

const dataHome = {
  title: 'Bienvenido al Portal de Trazabilidad',
  subtitle: 'de Facturación Electrónica',
  description: 'Este Portal está diseñado para facilitar el seguimiento y control de las facturas que ingresan a la Secretaría de Salud departamental, relacionadas con los servicios de salud prestados a la población a cargo de esta entidad territorial.',
  actions: [
    {
      icon: iconoDescarga,
      title: 'Exportar Facturas',
      description: 'Descarga todas las facturas electrónicas del sistema'
    },
    {
      icon: iconoSubir,
      title: 'Subir Soportes de Pago',
      description: 'Carga documentos de soporte para pagos realizados'
    },
    {
      icon: iconoContrato,
      title: 'Cargar Contratos',
      description: 'Carga contratos del sistema de salud'
    }
  ]
}

export const Home = () => {
  const dispatch = useDispatch<Dispatch>();
  const navigate = useNavigate();
  const { checkRoles } = useCheckRoleAccess();
  
  // Verificar si el usuario tiene permisos de administrador
  const isAdmin = checkRoles(accesRoles.adminUser);

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(0);
    dispatch.electronicDocuments.cleanState();
  }, [dispatch.electronicDocuments, dispatch.menuDrawer])

  const handleExportInvoices = () => {
    dispatch.electronicDocuments.getFileExcelToExport({
      url: "download",
      paramsUrl: { states: "" },
      text: "Archivo excel descargado"
    })
  }

  const handleOpenModalContract = () => {
    dispatch.messageModal.setMessageModal({
      show: true,
      title: 'Cargar nuevos contratos',
      size: 'medium',
      description: <ModalContract />,
      onClose: () => dispatch.messageModal.cleanStateMessage(),
    });
  };

  const handleUploadPaymentSupports = () => {
    navigate('/consulta_documentos_electronicos/cargar_soportes_pagos');
  };

  return (
    <Layout>
      <Box className={styles.containerHome}>
        <Container maxWidth="lg" className={styles.mainContainer}>
          {/* Header con logo */}
          <Box className={styles.header}>
            <img src={logoGobernacion2024} alt="Gobernación de Antioquia" className={styles.logo} />
          </Box>

          {/* Contenido principal */}
          <Box className={styles.heroSection}>
            <Typography className={styles.mainTitle} variant='h3'>
              {dataHome.title}
            </Typography>
            <Typography className={styles.subtitle} variant='h5'>
              {dataHome.subtitle}
            </Typography>
            <Typography className={styles.description} variant='body1'>
              {dataHome.description}
            </Typography>
          </Box>

          {/* Botones de acción - Solo visibles para administradores */}
          {isAdmin && (
            <Grid container spacing={1} className={styles.featuresGrid}>
              {dataHome.actions.map((action, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <RouterGuard roles={accesRoles.adminUser} type="component">
                    <Box className={styles.featureCard}>
                      <Box className={styles.cardContent}>
                        <Box className={styles.iconContainer}>
                          <img src={action.icon} alt={action.title} className={styles.featureIcon} />
                        </Box>
                        <Typography className={styles.cardTitle} variant='h6'>
                          {action.title}
                        </Typography>
                        <Typography className={styles.cardDescription} variant='body2'>
                          {action.description}
                        </Typography>
                        <Button 
                          variant='contained' 
                          className={styles.actionButton}
                          onClick={
                            action.title === 'Exportar Facturas'
                              ? handleExportInvoices
                              : action.title === 'Cargar Contratos'
                                ? handleOpenModalContract
                                : action.title === 'Subir Soportes de Pago'
                                  ? handleUploadPaymentSupports
                                  : undefined
                          }
                        >
                          {action.title}
                        </Button>
                      </Box>
                    </Box>
                  </RouterGuard>
                </Grid>
              ))}
            </Grid>
          )}
        </Container>
      </Box>
    </Layout>
  )
}
